export const SSO_VARIANT = {
  SOCIAL: 'social',
  CUSTOM: 'custom',
  NONE: 'none',
} as const;

export type SSO_VARIANT_KEY = (typeof SSO_VARIANT)[keyof typeof SSO_VARIANT];

export function getSSOVariant({
  authProvider,
  isEnterprise,
}: {
  authProvider?: string;
  isEnterprise?: boolean;
}): SSO_VARIANT_KEY {
  if (authProvider) {
    return SSO_VARIANT.CUSTOM;
  }
  if (isEnterprise) {
    return SSO_VARIANT.NONE;
  }
  return SSO_VARIANT.SOCIAL;
}
